__turbopack_context__.v({
  "addKeywordsBadge": "OfficeHoursView-module-scss-module__5Nf9sa__addKeywordsBadge",
  "alertButton": "OfficeHoursView-module-scss-module__5Nf9sa__alertButton",
  "alertMessageText": "OfficeHoursView-module-scss-module__5Nf9sa__alertMessageText",
  "badge": "OfficeHoursView-module-scss-module__5Nf9sa__badge",
  "badgesWrapper": "OfficeHoursView-module-scss-module__5Nf9sa__badgesWrapper",
  "calendarIconWrapper": "OfficeHoursView-module-scss-module__5Nf9sa__calendarIconWrapper",
  "col": "OfficeHoursView-module-scss-module__5Nf9sa__col",
  "description": "OfficeHoursView-module-scss-module__5Nf9sa__description",
  "detailItem": "OfficeHoursView-module-scss-module__5Nf9sa__detailItem",
  "detailText": "OfficeHoursView-module-scss-module__5Nf9sa__detailText",
  "detailTitle": "OfficeHoursView-module-scss-module__5Nf9sa__detailTitle",
  "details": "OfficeHoursView-module-scss-module__5Nf9sa__details",
  "emptyState": "OfficeHoursView-module-scss-module__5Nf9sa__emptyState",
  "emptyText": "OfficeHoursView-module-scss-module__5Nf9sa__emptyText",
  "incompleteStripAlert": "OfficeHoursView-module-scss-module__5Nf9sa__incompleteStripAlert",
  "keywordsLabel": "OfficeHoursView-module-scss-module__5Nf9sa__keywordsLabel",
  "keywordsWrapper": "OfficeHoursView-module-scss-module__5Nf9sa__keywordsWrapper",
  "linkBtn": "OfficeHoursView-module-scss-module__5Nf9sa__linkBtn",
  "missingData": "OfficeHoursView-module-scss-module__5Nf9sa__missingData",
  "officeHoursSection": "OfficeHoursView-module-scss-module__5Nf9sa__officeHoursSection",
  "primaryButton": "OfficeHoursView-module-scss-module__5Nf9sa__primaryButton",
  "primaryButtonWrapper": "OfficeHoursView-module-scss-module__5Nf9sa__primaryButtonWrapper",
  "root": "OfficeHoursView-module-scss-module__5Nf9sa__root",
  "setupPrompt": "OfficeHoursView-module-scss-module__5Nf9sa__setupPrompt",
  "subTitle": "OfficeHoursView-module-scss-module__5Nf9sa__subTitle",
  "subtext": "OfficeHoursView-module-scss-module__5Nf9sa__subtext",
  "titleHintLabel": "OfficeHoursView-module-scss-module__5Nf9sa__titleHintLabel",
  "warningMessageText": "OfficeHoursView-module-scss-module__5Nf9sa__warningMessageText",
});
